import {  createMemoryHistory, createRouter, createWebHashHistory } from "vue-router";
import { useStore } from 'vuex';

const routes = [
  { 
    name : 'trigger',
    path: "/",
    component: () => import("../components/EstimateView.vue") 
  },
  { 
    name : 'home',
    path: "/estimate", 
    component: () => import("../components/EstimateView.vue"),
    // beforeEnter: (to, from) => {
    //   // reject the navigation
    //   const store = useStore();
    //   store.commit('show');
    // },
  },
  { 
    name : 'payment',
    path: "/payment", 
    component: () => import("../components/PaymentView.vue")
  },
  { 
    name : 'thank-you',
    path: "/thank-you", 
    component: () => import("../components/ThankYou.vue")
  }
  
];
const router = createRouter({
    // 4. Provide the history implementation to use. We
    // are using the hash history for simplicity here.
    history: createMemoryHistory(),
    routes, // short for `routes: routes`
});

export default router;
